__webpack_require__.p = "/bedavailability/";